import * as XLSX from "xlsx";
import { showErrorSnackbar } from "../snackBar/snakbar";
import ExcelJS from "exceljs";
import {
  billingCurrencyOptions,
  entityOptions,
  gstCategoryOptions,
} from "../../utils/customerData";
import {
  getCodeTranslation,
  listHSN,
  listHSNSACmaster,
  listItemmasters,
  listPartymasters,
  listSAC,
} from "../../graphql/queries";
import { API, graphqlOperation } from "aws-amplify";
import { useGetCodeTranslationQuery } from "../../redux/apis/getCodeTranslation.api";
import { searchHSN } from "../../graphql";

const TaxabilityOpt = [
  { value: "Taxable", label: "Taxable" },
  { value: "Exempted", label: "Exempted" },
  { value: "Non-Taxable", label: "Non-Taxable" },
  { value: "GST Reverse charge", label: "GST Reverse charge" },
  { value: "Out Of Scope", label: "Out Of Scope" },
];
const taxOptions = TaxabilityOpt.map((opt) => opt.label);

const GstRates = ["0%", "5%", "12%", "18%", "28%"];



export const generateExcel = async (fields, module, cities, units) => {
  // Workbook setup
  let format = "xlsx";
  const wb = new ExcelJS.Workbook();
  const ws = wb.addWorksheet(module);

  let isSales = module === "Sales";
  let isPurchase = module === "Purchases";

  const firstele = `${module} Info`;
  let InfoHeaderRow = [firstele];
  let ItemHeaderRow = ["Item Details"];
  let nonItemRow = ["Non-Item Details"];
  let PaymentRow = ["Payment Details"];
  // Define headers
  const InfoHeaders = fields.filter((ele) => ele.type === "info");

  const itemDetailsHeaders = fields.filter(
    (ele) =>
      ele.flag === "item" ||
      ele.value === "Taxability" ||
      ele.value === "HSN/SACCode" ||
      ele.flag === "taxable" ||
      ele.value === "TotalTaxableAmount" ||
      ele.value === "NetAmount"
  );

  const nonItemDetailsHeaders = fields.filter(
    (ele) =>
      ele.flag === "non-item" ||
      ele.value === "Taxability" ||
      ele.value === "HSN/SACCode" ||
      ele.flag === "taxable" ||
      ele.value === "TotalTaxableAmount" ||
      ele.value === "NetAmount"
  );

  const paymentHeader = fields.filter(
    (ele) => ele.type === "payment" || ele.flag === "payment"
  );

  InfoHeaderRow = InfoHeaderRow.concat(Array(InfoHeaders.length - 1).fill(""));
  ItemHeaderRow = ItemHeaderRow.concat(
    Array(itemDetailsHeaders.length - 1).fill("")
  );
  PaymentRow = PaymentRow.concat(Array(paymentHeader.length - 1).fill(""));

  nonItemRow = nonItemRow.concat(
    Array(nonItemDetailsHeaders.length - 1).fill("")
  );

  // Starting data for headers
  const data = [
    [...InfoHeaderRow, ...ItemHeaderRow, ...nonItemRow, ...PaymentRow],
    [
      ...InfoHeaders.map((header) => header.label),
      ...itemDetailsHeaders.map((header) => header.label),
      ...nonItemDetailsHeaders.map((header) => header.label),
      ...paymentHeader.map((header) => header.label),
    ],
  ];

  const itemSheet = wb.addWorksheet(`Items`);
  const lookupSheet = wb.addWorksheet("LookupTable");
  let codesLength = 0;
  // lookupSheet.state = "hidden";
  // itemSheet.state = "hidden";
  let lookUpLength;
  if (isPurchase || isSales) {
    const PartyTypeCd = isSales ? "CUSTOMER" : "SUPPLIER";
    const partyMaster = await fetchPartyMaster(PartyTypeCd);
    partyMaster.map((items, i) => {
      const cellA = itemSheet.getCell(`E${i + 1}`);
      cellA.value = items?.PartyDisplayName;
      lookupSheet.addRow([
        items?.PartyDisplayName,
        items?.relatedPartyGstDetails[0].GSTIN,
      ]);
    });
    lookUpLength = partyMaster.length;
    ExcelSheetDropDowns("A3:A3", partyMaster, ws, "E");
    const response = await API.graphql(graphqlOperation(listItemmasters));
    let itemCodes = response?.data?.listItemmasters || [];
    let iCodes = [];
    itemCodes.map((items, i) => {
      const cellA = itemSheet.getCell(`D${i + 1}`);
      cellA.value = items.ItemCode;
      iCodes.push(items.ItemCode);
      // lookupSheet.addRow([items.ItemCode, items.ItemName, items.ItemID]);
      lookupSheet.getCell(`C${i + 1}`).value = items.ItemCode;
      lookupSheet.getCell(`D${i + 1}`).value = items.ItemName;
      codesLength += 1;
    });
    if (isSales) {
      ExcelSheetDropDowns("G3:G3", iCodes, ws, "D");
    } else {
      ExcelSheetDropDowns("H3:H3", iCodes, ws, "D");
    }
  }

  if (module === "Sales") {
    const codeData = await fetchHsnOrSacCode("HSN");
    if (codeData.length > 0) {
      codeData.map((items, i) => {
        const cellA = itemSheet.getCell(`C${i + 1}`);
        cellA.value = items;
      });
      ExcelSheetDropDowns("W3:W3", codeData, ws, "C");
      ExcelSheetDropDowns("K3:K3", codeData, ws, "C");
    }

    units.map((items, i) => {
      const cellA = itemSheet.getCell(`B${i + 1}`);
      cellA.value = items.option;
    });
    const unitOptions = units.map((opt) => opt.option);
    ExcelSheetDropDowns("M3:M3", unitOptions, ws, "B");

    const paymentType = ["Cash/Part Payment", "Bank/UPI/Card", "Credit"];
    ExcelSheetDropDowns("AB3:AB3", paymentType, ws);
    ExcelSheetDropDowns("J3:J3", GstRates, ws);
    ExcelSheetDropDowns("I3:I3", taxOptions, ws);
    ExcelSheetDropDowns("V3:V3", GstRates, ws);
    ExcelSheetDropDowns("U3:U3", taxOptions, ws);
  }
  if (module === "Sales" || module === "Purchases") {
    cities.map((items, i) => {
      const cellA = itemSheet.getCell(`A${i + 1}`);
      cellA.value = items.label;
    });
    const cityoptions = cities.map((opt) => opt.label);
    ExcelSheetDropDowns("C3:C3", cityoptions, ws, "A");
  }
  if (module === "Purchases") {
    ExcelSheetDropDowns("V3:V3", taxOptions, ws);
    ExcelSheetDropDowns("J3:J3", taxOptions, ws);
    ExcelSheetDropDowns("K3:K3", GstRates, ws);
    ExcelSheetDropDowns("W3:W3", GstRates, ws);

    const codeData = await fetchHsnOrSacCode("SAC");
    if (codeData.length > 0) {
      codeData.map((items, i) => {
        const cellA = itemSheet.getCell(`C${i + 1}`);
        cellA.value = items;
      });
      ExcelSheetDropDowns("L3:L3", codeData, ws, "C");
      ExcelSheetDropDowns("X3:X3", codeData, ws, "C");
    }
    units.map((items, i) => {
      const cellA = itemSheet.getCell(`B${i + 1}`);
      cellA.value = items.option;
    });
    const unitOptions = units.map((opt) => opt.option);
    ExcelSheetDropDowns("N3:N3", unitOptions, ws, "B");

    const paymentType = ["Cash/Part Payment", "Bank/UPI/Card", "Credit"];
    ExcelSheetDropDowns("AC3:AC3", paymentType, ws);
  }

  // Add data to worksheet
  data.forEach((row) => {
    ws.addRow(row);
  });

  // Set header row height

  if (isSales) {
    ws.getCell("K3").alignment = { vertical: "middle", horizontal: "justify" };
    ws.getCell("W3").alignment = { vertical: "middle", horizontal: "justify" };
    ws.getCell("H3").value = {
      formula: `VLOOKUP(G3, LookupTable!$C$1:$D${codesLength}, 2, FALSE)`,
      result: null,
    };
  }
  if (isPurchase) {
    ws.getCell("I3").value = {
      formula: `VLOOKUP(H3, LookupTable!$A$1:$B${codesLength}, 2, FALSE)`,
      result: null,
    };
  }

  if (isPurchase || isSales) {
    ws.getCell("B3").value = {
      formula: `VLOOKUP(A3, LookupTable!$A$1:$B${lookUpLength}, 2, FALSE)`,
      result: null,
    };
  }

  fields.forEach((header, index) => {
    ws.getColumn(index + 1).width = header.width || 24;
  });

  const headerRows = [1, 2];

  headerRows.forEach((rowNumber) => {
    const headerRow = ws.getRow(rowNumber);
    headerRow.height = 25;
    headerRow.eachCell((cell) => {
      cell.fill = {
        type: "pattern",
        pattern: "solid",
        fgColor: { argb: "e1f4f5" },
        bgColor: { argb: "e1f4f5" },
      };
      cell.font = {
        bold: true,
        color: { argb: "070808" },
      };
    });
  });

  // Format current date

  wb.xlsx.writeBuffer().then((buffer) => {
    let fileExtension, blob;
    if (format === "csv") {
      const csvContent = generateCSVContent(wb);
      blob = new Blob([csvContent], { type: "text/csv" });
      fileExtension = "csv";
    } else {
      blob = new Blob([buffer], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      fileExtension = "xlsx";
    }

    const Url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = Url;
    const currentDate = new Date();
    const formattedDate = currentDate.toISOString().slice(0, 10);
    const randomNumber = Math.floor(Math.random() * (9999 - 1000 + 1)) + 1000;
    link.setAttribute(
      "download",
      `ledgerX_import_data_${module}${randomNumber}_${formattedDate}.${fileExtension}`
    );
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  });
};



async function ExcelSheetDropDowns(col, options, sheet, i) {
  // set validation
  if (options.length > 10 || i) {
    sheet.dataValidations.add(col, {
      type: "list",
      allowBlank: false,
      formulae: [`Items!${i}$1:${i}${options.length}`],
    });
  } else {
    sheet.dataValidations.add(`${col}`, {
      type: "list",
      allowBlank: false,
      formulae: [`"${options.join(",")}"`],
    });
  }
}



async function fetchPartyMaster(party) {
  try {
    const partyMasterRes = await API.graphql(
      graphqlOperation(listPartymasters)
    );
    const partyMaster = partyMasterRes?.data?.listPartymasters;
    const filterPartyMaster = partyMaster.filter((element) => {
      return element?.PartyTypeCd === party;
    });
    return filterPartyMaster;
  } catch (error) {
    console.log(error);
  }
}

export const defaultTemplate = async (module, fields, format, cities, units, groupData) => {
  if (!format) {
    showErrorSnackbar("Error: Format not specified'");
    return;
  }
  if (!module) {
    showErrorSnackbar("Error: Module not selected");
    return;
  }
  let isCustomerOrSupplier =
    module === "Parties-Customer" || module === "Parties-Supplier";

  let isGoodsOrService = module === "Item-Goods" || module === "Item-Service";



  let isSales = module === "Sales";
  let isPurchase = module === "Purchases";
  let lookUpLength = 0;

  const options1 = [gstCategoryOptions?.map((opt) => opt.label)];
  const options2 = [entityOptions?.map((opt) => opt.label)];

  const options3 = cities.map((opt) => opt.label);
  const options4 = billingCurrencyOptions.map((opt) => opt.label);

  const workbook = new ExcelJS.Workbook();
  const splitText = module.split("-");
  const moduleName = splitText[1] || splitText[0];
  let worksheet = workbook.addWorksheet(moduleName);
  const itemSheet = workbook.addWorksheet(`Items`);
  itemSheet.state = "hidden";
  options3.map((items, i) => {
    const cellA = itemSheet.getCell(`A${i + 1}`);
    cellA.value = items;
  });
  const lookupSheet = workbook.addWorksheet("LookupTable");
  lookupSheet.state = "hidden";


  if (module === "Accounts" || module === "Groups") {
    let groups = []
    groupData.filter((item) => item.restrictedflag === 1).map((obj, i) => {
      const cellC = itemSheet.getCell(`C${i + 1}`);
      cellC.value = obj.accountgroupname
      groups.push(obj.accountgroupname)
      lookupSheet.addRow([obj.accountgroupname, obj.accountgroupid]);
      lookUpLength += i + 1
    });

    ExcelSheetDropDowns("C2:C2", groups, worksheet);
    ExcelSheetDropDowns("D2:D2", ["BS", "PANDL"], worksheet);
  }

  if (module === "Accounts") {
    ExcelSheetDropDowns("F2:F2", GstRates, worksheet);
    ExcelSheetDropDowns("G2:G2", ["Percentage", "Amount"], worksheet);
  }

  if (isCustomerOrSupplier) {
    ExcelSheetDropDowns("A2:A2", options1, worksheet);
    ExcelSheetDropDowns("D2:D2", options2, worksheet);

    ExcelSheetDropDowns("E2:E2", options3, worksheet, "A");
    ExcelSheetDropDowns("H2:H2", options4, worksheet);
  }

  if (isGoodsOrService) {
    units.map((items, i) => {
      const cellA = itemSheet.getCell(`B${i + 1}`);
      cellA.value = items.option;
    });
    const unitOptions = units.map((opt) => opt.option);
    ExcelSheetDropDowns("D2:D2", unitOptions, worksheet, "B");

    const codeData = await fetchHsnOrSacCode();
    codeData.map((items, i) => {
      const cellA = itemSheet.getCell(`C${i + 1}`);
      cellA.value = items;
    });
    ExcelSheetDropDowns("G2:G2", codeData, worksheet, "C");
    ExcelSheetDropDowns("H2:H2", taxOptions, worksheet);
    ExcelSheetDropDowns("I2:I2", ["Yes", "No"], worksheet);
    ExcelSheetDropDowns("K2:K2", GstRates, worksheet);
    ExcelSheetDropDowns("L2:L2", ["Amount", "Percentage"], worksheet);
  }

  if (isSales || isPurchase) {
    const itemMaster = await API.graphql(graphqlOperation(listItemmasters));
    const PartyTypeCd = isSales ? "CUSTOMER" : "SUPPLIER";
    const partyMaster = await fetchPartyMaster(PartyTypeCd);
    partyMaster.map((items, i) => {
      const cellA = itemSheet.getCell(`B${i + 1}`);
      cellA.value = items?.PartyDisplayName;
      lookupSheet.addRow([
        items?.PartyDisplayName,
        items?.relatedPartyGstDetails[0].GSTIN,
      ]);
    });
    lookUpLength = partyMaster.length;
    ExcelSheetDropDowns("A2:A2", options4, worksheet, "B");
    ExcelSheetDropDowns("C2:C2", options3, worksheet, "A");

    let itemCodes = itemMaster?.data?.listItemmasters || [];
    let iCodes = [];
    itemCodes.map((items, i) => {
      const cellA = itemSheet.getCell(`C${i + 1}`);
      cellA.value = items.ItemCode;
      iCodes.push(items.ItemCode);
      lookupSheet.addRow([items.ItemCode, items.ItemName, items.ItemID]);
      lookUpLength += 1;
    });
    if (isSales) {
      ExcelSheetDropDowns("G2:G2", iCodes, worksheet, "C");
    }
  }

  worksheet.addTable({
    name: "head",
    ref: "A1",
    headerRow: true,
    totalsRow: false,
    style: {
      theme: null,
      showFirstColumn: false,
      showLastColumn: true,
      showRowStripes: true,
    },
    columns: fields.map((header) => ({
      name: header.label,
    })),
    rows: [],
  });

  fields.forEach((header, index) => {
    worksheet.getColumn(index + 1).width = header.width || 22;
  });
  const headerRow = worksheet.getRow(1);
  headerRow.height = 22;
  headerRow.eachCell((cell) => {
    cell.fill = {
      type: "pattern",
      pattern: "solid",
      fgColor: { argb: "e1f4f5" },
      bgColor: { argb: "e1f4f5" },
    };
    cell.font = {
      bold: true,
      color: { argb: "070808" },
    };
    cell.alignment = {
      vertical: "middle",
      horizontal: "center",
    };
  });

  if (isSales || isPurchase) {
    worksheet.getCell("B2").value = {
      formula: `VLOOKUP(A2, LookupTable!$A$1:$B${lookUpLength}, 2, FALSE)`,
      result: null,
    };
    if (isSales) {
      worksheet.getCell("H2").value = {
        formula: `VLOOKUP(G2, LookupTable!$A$1:$B${lookUpLength}, 2, FALSE)`,
        result: null,
      };
      ["D2", "F2"].forEach((cellRef) => {
        const cell = worksheet.getCell(cellRef);
        cell.value = new Date();
        cell.numFmt = "mm-dd-yyyy";
      });
    }
  }

  workbook.xlsx.writeBuffer().then((buffer) => {
    let fileExtension, blob;
    if (format === "csv") {
      const csvContent = generateCSVContent(workbook);
      blob = new Blob([csvContent], { type: "text/csv" });
      fileExtension = "csv";
    } else {
      blob = new Blob([buffer], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      fileExtension = "xlsx";
    }

    const Url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = Url;
    const currentDate = new Date();
    const formattedDate = currentDate.toISOString().slice(0, 10);
    const randomNumber = Math.floor(Math.random() * (9999 - 1000 + 1)) + 1000;
    link.setAttribute(
      "download",
      `ledgerX_import_data_${module}${randomNumber}_${formattedDate}.${fileExtension}`
    );
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  });
};

const generateCSVContent = (workbook) => {
  const worksheet = workbook.getWorksheet(1);
  let csvContent = "";
  worksheet.eachRow((row) => {
    row.eachCell((cell, index) => {
      csvContent += cell.value + (index < row.cellCount ? "," : "");
    });
    csvContent += "\n";
  });
  return csvContent;
};

async function fetchHsnOrSacCode(value) {
  const word = value === "HSN" ? 0 : 9;
  let codesData;

  codesData = await API.graphql(
    graphqlOperation(searchHSN, {
      rowfrom: 0,
      limitno: 10000,
      word: word,
    })
  );

  const listKey = `list${value}`;
  const codesList = codesData.data[listKey];
  if (codesList !== null) {
    let arr = [];
    codesList?.forEach((item) => {
      arr.push(`${item.hsnsaccode} - ${item.description}`);
    });
    return arr;
  }
}
